import { useEffect, useContext } from 'react';
import perfilEmpresarilService from '../../services/perfilEmpresarial.js';
import { useUser } from '../../hooks/useUser.jsx';
import { GeneralContext } from '../../context/GeneralContext'

export const usePerfilEmpresarialActual = () => {
    const { user } = useUser()
    const { perfilEmpresarial, setPerfilEmpresarial } = useContext(GeneralContext);

    useEffect(() => {

        if (user?.id) {
            perfilEmpresarilService.getActual(user, user.language)
                .then(
                    (perfilEmpresarial) => {
                        setPerfilEmpresarial(perfilEmpresarial)
                    },
                    (y) => {
                        setPerfilEmpresarial(null)
                    }
                );
        }
    }, [user]);

    return { perfilEmpresarial };
}